// Avatar par défaut (couleur de fond dérivée du nom + initiales) et composant Avatar.
// Même mécanique que le concepteur (UserSelector.vue), partagée entre les vues.

const COULEURS_AVATAR = ['#1E40AF', '#0F766E', '#4338CA', '#9A3412', '#7C2D12', '#BE185D', '#475569'];

export const obtenirInitiales = (nomComplet) => {
    if (!nomComplet) return '?';
    const morceaux = nomComplet.trim().split(/\s+/).filter(Boolean);
    if (!morceaux.length) return '?';
    if (morceaux.length === 1) return morceaux[0].slice(0, 2).toUpperCase();
    return `${morceaux[0][0] ?? ''}${morceaux[morceaux.length - 1][0] ?? ''}`.toUpperCase();
};

const calculerHashTexte = (texte) => {
    if (!texte) return 0;
    let hash = 0;
    for (let i = 0; i < texte.length; i++) {
        hash = (hash << 5) - hash + texte.charCodeAt(i);
        hash |= 0;
    }
    return Math.abs(hash);
};

export const obtenirCouleurAvatar = (nomComplet) =>
    COULEURS_AVATAR[calculerHashTexte(nomComplet) % COULEURS_AVATAR.length];

// Avatar rond : photo de profil si disponible, sinon fond coloré + initiales.
export function Avatar({ url, nom, size = 36 }) {
    if (url) {
        return (
            <img
                src={url}
                alt=""
                style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', display: 'block', flexShrink: 0 }}
            />
        );
    }
    return (
        <div style={{
            width: size,
            height: size,
            borderRadius: '50%',
            flexShrink: 0,
            backgroundColor: obtenirCouleurAvatar(nom),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#FFFFFF',
            fontWeight: 600,
            fontSize: `${Math.round(size * 0.42)}px`,
        }}>{obtenirInitiales(nom)}</div>
    );
}
